// lib/components/form/common/required.tsx
import { jsx } from "@emotion/react/jsx-runtime";
var Required = () => /* @__PURE__ */ jsx(
  "span",
  {
    style: {
      display: "inline-block",
      background: "#F14668",
      color: "#FFFFFF",
      fontSize: "0.6em",
      padding: "0em 0.2em"
    },
    children: "\u5FC5\u9808"
  }
);

export {
  Required
};
